import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "sonner";
import RecruitingSite from "@/pages/RecruitingSite";
import Admin from "@/pages/Admin";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

function LenisProvider({ children }) {
    useEffect(() => {
        const lenis = new Lenis({
            duration: 1.15,
            easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
            smoothWheel: true,
            wheelMultiplier: 1,
        });
        function raf(time) {
            lenis.raf(time);
            requestAnimationFrame(raf);
        }
        requestAnimationFrame(raf);
        return () => lenis.destroy();
    }, []);
    return children;
}

function App() {
    useEffect(() => {
        axios.post(`${API}/analytics/event`, { type: "visit" }).catch(() => {});
    }, []);
    return (
        <BrowserRouter>
            <LenisProvider>
                <div className="noise min-h-screen bg-black text-white">
                    <Routes>
                        <Route path="/" element={<RecruitingSite />} />
                        <Route path="/admin" element={<Admin />} />
                    </Routes>
                </div>
                <Toaster theme="dark" position="bottom-right" />
            </LenisProvider>
        </BrowserRouter>
    );
}

export default App;
